// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "20485aa-dirty",
    "hash": "20485aa",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "20485aa-dirty",
    "semverString": null,
    "frontend": "2.37.6",
    "version": "2.37.6",
    "buildAt": "2026-11-04T19:46:17.795Z",
    "branch": "HEAD"
};
/* tslint:enable */
